import React from "react";
import { useMediaQuery } from "react-responsive";
import { useAppState } from "../../AppContext";
import { breakpoints } from "../../utils/styleUtils";

type IsDesktopProps = {
  children: React.ReactNode;
};

const IsDesktop = ({ children }: IsDesktopProps) => {
  const isBigScreen = useMediaQuery({ query: breakpoints[10] });
  const { state } = useAppState();
  return isBigScreen && !state.initializing ? <>{children}</> : <>{null}</>;
};

export default IsDesktop;
